import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=62107fe5&scoped=true"
var script = {}
import style0 from "./testing.vue?vue&type=style&index=0&id=62107fe5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62107fe5",
  null
  
)

export default component.exports